import { nanoid } from "nanoid";

export const TEMP_PREFIX = "TEMP_ID";

export const generateTempId = () => `${TEMP_PREFIX}_${nanoid()}`;

export const isTempId = (id) => id?.startsWith(TEMP_PREFIX);
export const generateUUID = () => `${nanoid()}`;
